//created by sudip
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

interface FloatingInsightBadgeProps{
    accent:string;
}

export function FloatingInsightBadge({

    accent,

}:FloatingInsightBadgeProps){

    return(

        <motion.div

            animate={{
                scale:[1,1.04,1],
            }}

            transition={{
                duration:3,
                repeat:Infinity,
            }}

            className="
                absolute
                left-16
                top-8
                z-40
                flex
                items-center
                gap-2
                rounded-full
                border
                border-white/60
                bg-white/95
                px-4
                py-2
                shadow-xl
            "
        >

            <Sparkles
                className="h-4 w-4"
                style={{
                    color:accent,
                }}
            />

            <span
                className="text-xs font-semibold"
                style={{
                    color:accent,
                }}
            >

                Predictive Insight Generated

            </span>

        </motion.div>

    );

}